/** 인문대학 이수요건 — 데이터 미입력 (학과 목록 추가 필요) */
export const HUMANITIES_REQUIREMENTS = []
